module.exports = {"tel":"Telefon","fax":"Fax","email":"E-Mail","meeting":"Meeting","training":"Schulung","letter":"Brief","conference":"Telefonkonferenz","other":"Sonstige","tel_in":"eingehend","tel_out":"ausgehend","fax_in":"eingehend","fax_out":"ausgehend","email_in":"eingehend","email_out":"ausgehend","meeting_in":"intern","meeting_out":"extern","training_in":"intern","training_out":"extern","letter_in":"eingehend","letter_out":"ausgehend","conference_in":"eingehend","conference_out":"ausgehend"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/activity/de.json
// module id = 1400
// module chunks = 1